<template>
    <Head title="My Next Card" />
    <div class="px-4 md:px-8">
        <NextCard />
    </div>
</template>

<script setup>
import { Head } from '@inertiajs/vue3';
import NextCard from '@/components/next-card/index.vue';
</script>
